// 医院配置信息
import self from '@/common/utils/global-config';
import * as Constants from '@/common/utils/constants';

export function getConfig() {
  return getHospitalConfig(self.$sn.utils.getHospitalId());
}

export function getHospitalConfig(hosId) {
  let config = new Config();
  config.hosId = hosId;
  if (hosId === Constants.HOSPITAL_ID_JNRM) {
    config.hosTitle = '济南市人民医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_TAFY) {
    config.hosTitle = '泰安市妇幼保健院';
  }
  else if (hosId === Constants.HOSPITAL_ID_TAZX) {
    config.hosTitle = '泰安中心医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_SDSL) {
    config.hosTitle = '山东省立医院';
    config.pcEntranceArea = true; // 入口页面是否为选择院区
  }
  else if (hosId === Constants.HOSPITAL_ID_QDSL) {
    config.hosTitle = '青岛市市立医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_JNFY) {
    config.hosTitle = '济南市妇幼保健院';
  }
  else if (hosId === Constants.HOSPITAL_ID_LCNK) {
    config.hosTitle = '聊城市脑科医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_JNSJGYY) {
    config.hosTitle = '济南市第七人民医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_SLX) {
    config.hosTitle = '山东省第二人民医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_WSRM) {
    config.hosTitle = '微山县人民医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_NYXDYRM) {
    config.hosTitle = '宁阳县第一人民医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_LCRM) {
    config.hosTitle = '聊城市人民医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_JNSSZQRM) {
    config.hosTitle = '济南市市中区人民医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_YTSBH) {
    config.hosTitle = '烟台市北海医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_YTLL) {
    config.hosTitle = '玲珑英诚医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_SDQL) {
    config.hosTitle = '山东大学齐鲁医院';
    config.pcEntranceArea = true; // 入口页面是否为选择院区；ps：因当前配置需在路由初始化使用，故不使用配置表
  }
  else if (hosId === Constants.HOSPITAL_ID_HZSL) {
    config.hosTitle = '菏泽市立医院';
  }
  else if (hosId === Constants.HOSPITAL_ID_SDSZL) {
    config.hosTitle = '山东省肿瘤医院';
  }
  config = {
    ...config
  };
  return config;
}

export class Config {
  constructor() {
    // 医院信息
    this.hosId = ''; // 医院 ID
    this.pcEntranceArea = false; // 入口页面是否为选择院区；ps：因当前配置需在路由初始化使用，故不使用配置表
  }
}
